function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13 1C6.376 1 1 6.376 1 13C1 19.624 6.376 25 13 25C19.624 25 25 19.624 25 13C25 6.376 19.624 1 13 1Z",
  stroke: "#A0A0A0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.0602 21.8889C14.2237 21.8889 14.2942 20.7253 14.2942 20.7253C14.3648 19.456 14.3648 19.4208 14.0474 16.1417C13.7301 12.8627 11.121 12.1222 11.121 12.1222C8.3128 11.1038 6.07181 11.598 5.55627 11.7371C5.5151 11.7483 5.51042 11.8027 5.54837 11.8221C6.01618 12.0616 7.94356 13.0833 8.89967 14.1319C9.99269 15.3307 9.99269 16.8468 9.99269 16.8468C9.99269 16.8468 10.169 19.3855 11.121 20.7253C11.121 20.7253 11.8967 21.8889 13.0602 21.8889ZM13.0602 21.8889C13.0602 21.8889 12.4772 20.893 12.2492 20.1965C12.0056 19.452 11.8967 18.222 11.8967 18.222",
  stroke: "#A0A0A0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M15.7753 13.8848C15.7753 13.8848 15.0557 14.7727 14.7528 15.3304C14.4499 15.888 14.1182 16.917 14.1182 16.917",
  stroke: "#A0A0A0"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M10.2744 11.8851C10.2744 11.8851 10.8033 4.75959 13.4829 5.00626C14.415 5.09206 15.0698 5.72857 15.5274 6.52232M16.5504 10.0517C16.5504 10.0517 16.3855 8.01061 15.5274 6.52232M15.5274 6.52232H14.1176",
  stroke: "#A0A0A0"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M11.5793 6.55127H12.9544M14.9289 7.99687H15.9514M12.1082 7.99687H11.0505M14.2943 7.99687H12.7781M16.2687 9.5835H15.2462M10.6626 9.5835H11.8614M12.7781 9.5835H14.2943M14.2943 10.9586H12.6371M10.4863 10.9586H11.8614M12.9544 12.2984H14.2943",
  stroke: "#A0A0A0"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M13.4834 14.2027C13.4834 14.2027 14.6822 11.4173 15.9162 10.4301C17.0234 9.54433 20.3159 8.51668 20.9813 8.31474C21.0232 8.30202 21.0561 8.34841 21.033 8.38555L18.9664 11.6977C18.6743 12.1658 18.4615 12.6775 18.3229 13.2115C17.9815 14.5277 17.2428 17.1922 16.3746 19.2094C15.1758 21.9949 13.7302 21.7481 13.7302 21.7481",
  stroke: "#A0A0A0"
});

function SvgCornIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCornIcon);
export default __webpack_public_path__ + "static/media/CornIcon.4d9788fc.svg";
export { ForwardRef as ReactComponent };